// Shared, fluid styles for the Become-a-Rider / Merchant / Contact forms.
// Every input stretches to its column so the form works from 320px phones
// up to wide desktops without fixed pixel widths.
export const fieldContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 0,
  marginBottom: "18px",
};

export const fieldLabel = {
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 600,
  lineHeight: "18px",
  color: "#1f2937",
  marginBottom: "6px",
};

export const fieldInput = {
  width: "100%",
  boxSizing: "border-box",
  height: "46px",
  borderRadius: "10px",
  border: "1px solid #E2E2E2",
  backgroundColor: "#fff",
  padding: "0 14px",
  fontFamily: "Inter",
  fontSize: "14px",
  fontWeight: 400,
  color: "#111",
  outline: "none",
  transition: "border-color .15s, box-shadow .15s",
  "&::placeholder": {
    fontSize: "13px",
    fontWeight: 400,
    color: "#A3A3A3",
  },
  "&:focus": {
    borderColor: "#D25A26",
    boxShadow: "0 0 0 3px rgba(210, 90, 38, 0.15)",
  },
};

export const twoFieldRow = (theme) => ({
  display: "flex",
  flexDirection: "row",
  gap: "14px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: 0,
  },
});
